// extracted by mini-css-extract-plugin
module.exports = {"container":"AcceptPrivacy_container__3aFOQ","text":"AcceptPrivacy_text__21RPF"};